<!--
 * @Description: 校本选课-学生端-课程详情
 * @Autor: chenJunHui
 * @Date: 2022-07-11 17:05:39
 * @LastEditors: chenJunHui
 * @LastEditTime: 2022-07-12 10:27:56
-->
<template>
  <div class="index" v-loading="loading">
    <div class="header">
      <div class="left" @click="toIndex()">
        <img src="@/assets/img/courseSelection/left_icon.svg" alt="" />
        <span>返回</span>
      </div>
      <div class="span1">
        <span> 课程详情</span>
      </div>
      <div class="right"></div>
    </div>
    <div class="box_p">
      <div class="box_top">
        <!-- <img :src="applyMsg.pic" alt="" class="box_top_img" v-if="applyMsg.pic"/>
                <template v-else> -->
        <img
          src="@/assets/img/courseSelection/study.svg"
          class="box_top_img"
          alt=""
          v-if="applyMsg.typeName !== '作业辅导'"
        />
        <img
          src="@/assets/img/courseSelection/job.svg"
          class="box_top_img"
          alt=""
          v-if="applyMsg.typeName == '作业辅导'"
        />
        <!-- </template> -->
        <div class="box_top_font">
            <div class="box_top_title">
                <span  v-if="applyMsg.courseName" style="display: inline-block;" class="course_name">{{ info.courseName }} </span>
                <span  v-if="applyMsg.typeName" style="display: inline-block;margin:0 0 0 10px"  class="course_text">{{ applyMsg.parentTypeName?applyMsg.parentTypeName+' - ':'' }}{{applyMsg.typeName }}</span>
            </div>
          <!-- <p class="course_name" v-if="applyMsg.courseName">
            {{ info.courseName }}
          </p>
          <div class="course_text" v-if="applyMsg.typeName" style="margin-top:12px">
             {{ applyMsg.parentTypeName?applyMsg.parentTypeName+' - ':'' }}{{applyMsg.typeName }} 
          </div> -->

          <div class="course_last">
            <div class="course_text mr-30" v-if="applyMsg.teacherName">
              <span>任课教师：</span>
              <span>{{ applyMsg.teacherName }}</span>
            </div>
            <div class="course_text mr-30" v-if="applyMsg.classTimeName">
              <span>上课时间：</span>
              <span>{{ applyMsg.classTimeName }}</span>
            </div>

            <div class="selected_box" v-if="applyMsg.totalLimit">
              <span class="font-gray">选课人数</span>
              <div class="progress_box" v-if="applyMsg.totalLimit != 99999">
                <div class="progress_outside">
                  <div
                    class="progress_Within"
                    :style="{
                      width: `${
                        ((applyMsg.selectedCount || 0) /
                          1 /
                          ((applyMsg.totalLimit || 0) / 1)) *
                        114
                      }px`,
                    }"
                  ></div>
                </div>
                <div>
                  <span style="color: #4991e1">{{
                    applyMsg.selectedCount || 0
                  }}</span>
                  <span style="color: #000000"
                    >/{{ applyMsg.totalLimit || 0 }}</span
                  >
                </div>
              </div>
              <p style="margin-left: 10px" v-else>不限</p>
            </div>
          </div>
        </div>
      </div>
      <div class="right_box">
        <button class="btn" @click="selectionCourse(getBtnText())" :disabled="getBtnText() != '立即报名' && getBtnText() != '取消报名'">{{ getBtnText() }}</button>
        <div
              class="red_state"
              v-if="applyMsg.activity && applyMsg.activity.status==2 && getEndDistance(applyMsg)"
            >
              <img src="@/assets/img/courseSelection/red_clock.svg" alt="" />
              <p>
                距选课结束还剩 {{ getEndDistance(applyMsg) }}
              </p>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="rows" v-if="applyMsg.description">
        <p class="rows_gary">课程介绍：</p>
        <p class="rows_black">{{applyMsg.description}}</p>
      </div>
      <div class="rows" v-if="applyMsg.teacherInfo">
        <p class="rows_gary">老师介绍：</p>
        <p class="rows_black">{{applyMsg.teacherInfo}}</p>
      </div>
    </div>
  </div>
</template>
<script>
import util from "@/utils/util.js";
import _ from "lodash";
import api from "@/api/wisdomSchool/index";
export default {
  props: ["info"],
  data() {
    return {
      loading: false,
      item: {},
      cid: '',
      applyMsg: {},
      class_id: '',
      userInfo: JSON.parse(sessionStorage.userInfo) || {},
    };
  },
  watch: {
    info: {
      handler(n, o) {
        this.cid = n.courseId
        this.getDetail();
      },
      deep: true,
      immediate: false,
    },
  },
  created() {
    // 获取班级信息
    let classList = this.userInfo.user_org.filter((e) => e.org_type == "7");
    this.class_id = classList[0]?.org_id;
  },
  methods: {
    toIndex() {
      this.$emit("to-index");
    },
    async getDetail() {
      try {
        this.loading = true;
        let params = {
          courseId: this.cid,
          orgId: sessionStorage.orgId,
          platformCode: sessionStorage.loginPlatformCode,
          studentId: this.userInfo.user_id,
        };
        let res = await api.getCourseApplyMsg(params);
        console.log('开课详情---', res);
        if (res.code === '0') {
          this.applyMsg = res.data;
        }
      } catch (err) {
        console.log(err);
      } finally{
        this.loading = false;
      }
    },
    getEndDistance(info) {
      if (info.activity && info.activity.studentEndTime && Date.parse(info.activity.studentEndTime.replace(/-/g,'/')) > Date.parse(new Date())) {
        return util.endDistance(new Date(), new Date(info.activity.studentEndTime.replace(/-/g,'/')));
      } else {
        return '';
      }
    },
    selectionCourse: _.throttle(
     async function (type) {
         try {
            this.loading = true;
            if(type === '立即报名'){
              let params = {
                courseApplyId: this.applyMsg.id,
                platformCode: sessionStorage.loginPlatformCode,
                userId: this.userInfo.user_id,
                classId: this.class_id,
                orgId: sessionStorage.orgId,
                creatorId: this.userInfo.user_id,
              }
              let res = await api.selectCourse(params);
              console.log('报名',res)
              if(res.code === '0'){
                this.$message.success({
                  message: "报名成功",
                  offset: 200,
                  customClass: "toast-classManage",
                  duration: 1500,
                })
                this.getDetail();
              }else{
                  this.$message.error({
                  message: res.msg,
                  offset: 200,
                  customClass: "toast-classManage",
                  duration: 1500,
                })
              }
            }else{
              let params = {  
                courseApplyId: this.applyMsg.id,//待取消开课业务ID
                courseUserId: this.applyMsg.courseUserId,//用户选课表记录Id
                applyId: this.applyMsg.applyId,//选课业务ID
                platformCode: sessionStorage.loginPlatformCode,
                orgId: sessionStorage.orgId,
                creatorId: this.userInfo.user_id,//操作人Id
              }
              let res = await api.dropCourse(params);
              console.log('取消报名',res)
              if(res.code === '0'){
                this.$message.success({
                  message: "取消成功",
                  offset: 200,
                  customClass: "toast-classManage",
                  duration: 1500,
                })
                this.getDetail();
              }else{
                  this.$message.error({
                  message:res.msg,
                  offset: 200,
                  customClass: "toast-classManage",
                  duration: 1500,
                })
              }
            }
          } catch (err) {
            console.log(err);
          } finally {
            this.loading = false;
          }   
      },
      3000,
      { leading: true, trailing: false }
    ),
    getBtnText() {
      if (this.applyMsg.activity) {
        switch (this.applyMsg.activity.status) {
          case 1:
          case '1':
            return '报名未开始';
          case 2:
          case '2':
            // courseUserId: 该字段存在则证明已选
            if (!this.applyMsg.courseUserId){
              if (this.applyMsg.selectedCount < this.applyMsg.totalLimit) {
                return '立即报名';
              } else {
                return '名额已满';
              }
            }else{
              return '取消报名';
            }
          case 3:
          case '3':
          case 4:
          case '4':
            return '报名已截止';
          case 5:
          case '5':
            return '开课中';
        }
      } else {
        return '无法报名';
      }
    },
  },
};
</script>

<style lang="less" scoped>
.index {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  overflow: hidden;
  padding: 0 20px 20px;
  .box_p {
    width: 100%;
    background: #ffffff;
    border-radius: 12px;
    padding: 12px 15px;
    position: relative;
    left: 0;
    bottom: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #DEDEDE;
    .box_top_img {
        width: 110px;
        height: 82px;
        margin-right: 15px;
    }
  }
  .box_top {
    display: flex;
    margin-top: 10px;
    width: calc(100% - 218px);
    .box_top_font {
      width: calc(100% - 127px);
       .box_top_title{
            display: flex;
            align-items: center;
          }
      .course_name {
        font-size: 18px;
        line-height: 25px;
      }
      .course_text {
        color: #888888;
        font-size: 12px;
        line-height: 17px;
        margin-top: 9px;
        display: -webkit-box;
      }
    }
  }
  .selected_box {
    display: flex;
    align-items: center;
    font-size: 12px;
    line-height: 17px;
    color: #9b9b9b;
    margin-top: 9px;
    .progress_box {
      display: flex;
      align-items: center;
      margin-left: 6px;

      .progress_outside {
        position: relative;
        width: 114px;
        height: 10px;
        background: #e8f0fa;
        border-radius: 25px;
        margin-right: 11px;
        .progress_Within {
          position: absolute;
          left: 0;
          top: 0;
          height: 10px;
          background: linear-gradient(270deg, #41a4ff 50%, #7ec1ff 89.51%);
          border-radius: 25px;
        }
      }
    }
  }
  .btn {
    min-width: 58px;
    height: 29px;
    padding: 4.5px 10px;
    color: #4991E1;
    border: 1px solid #4991E1;
    border-radius: 3px;
    font-size: 14px;
    line-height: 20px;
    background-color: #ffffff;
    cursor: pointer;
  }
  .btn[disabled] {
    opacity: 0.5;
    cursor: no-drop;
    color: #888888;
    border: 1px solid #888888;
  }
  // .course_last {
  //   display: flex;
  //   align-items: center;
  //   flex-wrap: wrap;
  // }
  .mr-30 {
    margin-right: 30px;
  }
  .right_box{
    width: 218px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    position: relative;
  }
  .red_state {
    font-size: 12px;
    line-height: 17px;
    color: #FA5151;
    display: flex;
    align-items: center;
    position: absolute;
    bottom: -30px;
    right: 0;
    img {
      margin-right: 7px;
    }
  }
}
.content{
  width: 100%;
  margin-top: 40px;
  padding: 0px 15px;
  .rows{
    width: 100%;
    margin-bottom: 24px;
    display: flex;
    .rows_gary{
      width: 80px;
      font-size: 14px;
      line-height: 20px;
      color: #8B8B8B;
    }
    .rows_black{
      width: calc(100% - 80px);
      font-size: 14px;
      line-height: 20px;
      color: #000000;
    }
  }
}
.header {
  width: 100%;
  text-align: center;
  color: #000000;
  padding-top: 17px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ececec;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .span1 {
    font-size: 18px;
    color: #000;
    margin-right: 30px;
  }
  .left,
  .right {
    width: 60px;
  }
  .left {
    color: #8b8b8b;
    cursor: pointer;
    img {
      margin-right: 5px;
    }
  }
}
</style>